import { BrowserRouter } from 'react-router-dom';
import AppRouter from './AppRouter';
import './main.scss';
import React, { useEffect } from "react";
import { useGetBasicDetailsMutation } from "./lib/services/eligibilityApi";
import { clevertapIdentitySet } from "./lib/middleware/CtEvents";
import Maintenance from "./Maintenance/Maintenance";

// Maintenance mode: takes the whole app offline behind a notice screen.
// Flip to false (and redeploy) to bring the app back.
const MAINTENANCE_MODE = false;

function App() {
  const [getBasicDetails, { data, isSuccess }] = useGetBasicDetailsMutation();

  useEffect(() => {
    if (MAINTENANCE_MODE) return;
    const scrt = localStorage.getItem("secret");
    const jwt_token = localStorage.getItem("jwt");

    if (scrt && jwt_token) {
      getBasicDetails({ scrt, jwt_token });
    }
  }, []);

  useEffect(() => {
    if (MAINTENANCE_MODE) return;
    if (isSuccess && data) {
      const identity = data?.customer_id;
      if (identity) {
        clevertapIdentitySet({ identity });
      }
    }
  }, [isSuccess, data]);

  if (MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <BrowserRouter>
      <div className="App">
        <AppRouter />
      </div>
    </BrowserRouter>
  );
}

export default App;
